import { css } from 'styled-components'

const lstPxs = [115, 290, 170, 260, 170, 170, 170, 170, 170, 450, 500]
const gridArr = lstPxs.map((item) =>
    typeof item === 'number' ? `${item}px` : item
)

const extendStylesTable = css`
    .header,
    .row {
        grid-template-columns: ${gridArr.join(' ')};
    }
`

export { extendStylesTable }
